<script setup>
import { computed, defineProps } from 'vue'
import { cn } from '@/lib/utils'
import { ToastDescription } from 'radix-vue'

const props = defineProps({
  class: { type: String, default: '' }
})

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastDescription :class="cn('text-sm opacity-90', props.class)" v-bind="delegatedProps">
    <slot />
  </ToastDescription>
</template> 